module.exports = __webpack_public_path__ + "img/siren-on.eedb7d50.svg";